import { For, Show } from 'solid-js';
import clsx from 'clsx';
import { useAppContext } from '../../app-context-provider/app-context-provider';

export type CategoryOption = {
    name: string;
    slug: string;
};

export type CategoryFilterProps = {
    categories: CategoryOption[];
    selectedSlug?: string;
    onSelect: (slug: string | undefined) => void;
    class?: string;
};

const tagClasses = (active?: boolean) =>
    clsx(
        'border-1',
        'mb-xxs',
        'border-secondary-600',
        'px-s',
        'text-secondary-600',
        'hover:bg-secondary-600',
        'hover:text-white',
        'text-medium',
        'inline-block',
        'rounded-l',
        'py-[0.31rem]',
        'transition-colors',
        'duration-200',
        { 'bg-secondary-600': active },
        { '!text-white': active },
    );

export const CategoryFilter = (props: CategoryFilterProps) => {
    const { translate } = useAppContext();
    const categories = () => props.categories ?? [];
    const isActive = (slug?: string) => (props.selectedSlug || undefined) === slug;

    return (
        <Show when={categories().length > 0}>
            <div class={clsx('mb-l tablet:mt-xxl gap-x-xxs flex flex-wrap', props.class)}>
                <button
                    type="button"
                    aria-label={`${translate('filter-on')} ${translate('all')}`}
                    aria-pressed={isActive(undefined)}
                    onClick={() => props.onSelect(undefined)}
                    class={tagClasses(isActive(undefined))}>
                    {translate('all')}
                </button>
                <For each={categories()}>
                    {(category) => (
                        <button
                            type="button"
                            aria-label={`${translate('filter-on')} ${category.name}`}
                            aria-pressed={isActive(category.slug)}
                            onClick={() => props.onSelect(category.slug)}
                            class={tagClasses(isActive(category.slug))}>
                            {category.name}
                        </button>
                    )}
                </For>
            </div>
        </Show>
    );
};
